// extracted by mini-css-extract-plugin
export default {"primaryButton":"styles_primaryButton__kbZlt","primaryButtonText":"styles_primaryButtonText__ltQaj"};